/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.10.2018
 * Copyright: xdot GmbH 2018
 */
import { ActionTypes } from '../constants/Constants';
import { ReduceStore } from 'plugin/liferay-widgets-react-web';

export default class TitleStore extends ReduceStore {
    constructor(dispatcher) {
        super(dispatcher);
    }

    getInitialState() {
        return {
            requested: {},
            titles: {}
        };
    }

    filterNotRequested(keys) {
        return keys.filter(key => {
            return !this.isRequested(key);
        });
    }

    getTitleFromKey(key) {
        const titles = this.getState().titles;
        return titles[ key ];
    }

    isRequested(key) {
        const requested = this.getState().requested;
        return requested[ key ] !== undefined;
    }

    reduce(state, action) {
        let newState = state;
        if (action.type === ActionTypes.TITLES_REQUEST) {
            newState = {
                ...state
            };

            action.payload.keys.forEach(key => {
                newState.requested[key] = action.payload.xhr;
            });

            return newState;
        }
        if (action.type === ActionTypes.TITLES_UPDATE) {
            for (const property in action.payload.lookUpResult) {
                if (action.payload.lookUpResult.hasOwnProperty(property)) {
                    const storeTitle = state.titles[ property ];
                    const requestedTitle = action.payload.lookUpResult[ property ];
                    if (storeTitle !== requestedTitle) {
                        newState = {
                            titles: {
                                ...newState.titles,
                                [ property ]: requestedTitle
                            },
                            requested: newState.requested
                        };
                        delete newState.requested[ property ];
                    }
                }
            }

            if (newState !== state) {
                return newState;
            }
        }
        return state;
    }
}


// WEBPACK FOOTER //
// ./js/stores/TitleStore.js